function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary-18{fill:none;}.primary-18{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}.cls-2{fill:#4f4954;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary-18",
  cx: 128,
  cy: 128,
  r: 96
}), React.createElement("path", {
  className: "cls-2",
  d: "M118.45,147.71a36.93,36.93,0,0,1,.93-8.67,20.61,20.61,0,0,1,4-7.36l16.83-20.78c3.13-3.92,4.69-7.61,4.69-11a13.7,13.7,0,0,0-5.33-11A18.91,18.91,0,0,0,128.08,85q-7.64,0-12.49,4-5.52,4.17-5.53,14.23H90.19V99.87a28.53,28.53,0,0,1,11.13-22.74q10.77-9,25.71-9.13,15.24.16,26.18,8.47Q164.53,85.2,164.73,100q-.18,10.56-6.07,17.59l-17.09,20.94a15.67,15.67,0,0,0-3.22,10.55v9.55h-19.9Zm0,23.31h19.9v17h-19.9Z"
})));
var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Help.46428d3f.svg";
export { ForwardRef as ReactComponent };